import { createRoot } from 'react-dom/client';
import $ from '../Globals/Scripts/jquery-loadplugins';  // although the $ variable is not directly used in this file, importing this module sets up jQuery components as a side-effect.
import Browser from '../Utilities/Browser';
import '../Globals/Scripts/GlobalEventHandlers';
import ImmerSetUp from '../Globals/Scripts/ImmerSetUp';
import './App.less';
import './App.scss';
import AutomaticSessionLogoutWatchdog from "../../Common/Utilities/AutomaticSessionLogoutWatchdog";

const loadApp = routes => {
    function run(event){
        const root = createRoot(document.getElementById('ReactApp'));
        root.render(routes);
    }

    if(AutomaticSessionLogoutWatchdog.shouldAbortPageLoad())
        return;

    ImmerSetUp.run();

    AutomaticSessionLogoutWatchdog.install();

    if(Browser.document.readyState !== "loading")
        run();
    else
        Browser.window.addEventListener('DOMContentLoaded', run);
};

export { loadApp };
